/**
 * @format
 */
import EventBus from '@/scripts/event-bus';

export const FroalaMixin = {
    data() {
        return {
            froalaConfig: {
                key: this.$helpers.getFroalaKey(),
                charCounterCount: false,
                listAdvancedTypes: false,
                toolbarButtons: [
                    'paragraphFormat',
                    'fontFamily',
                    'fontSize',
                    'align',
                    'bold',
                    'italic',
                    'campaignFooterColorPicker',
                    'insertLink',
                ],
                fontSize: [
                    '8',
                    '9',
                    '10',
                    '11',
                    '12',
                    '13',
                    '14',
                    '15',
                    '16',
                    '17',
                    '18',
                    '19',
                    '20',
                    '22',
                    '24',
                    '26',
                    '28',
                    '30',
                    '32',
                    '34',
                    '36',
                    '40',
                    '44',
                    '48',
                    '52',
                    '56',
                    '64',
                ],
                paragraphFormat: {
                    N: 'Normal',
                    H1: 'Heading 1',
                    H2: 'Heading 2',
                    H3: 'Heading 3',
                },
                fontFamily: this.$helpers.fontStyles,
                paragraphFormatSelection: true,
                fontSizeSelection: true,
                fontFamilySelection: true,
                events: {
                    'froalaEditor.contentChanged': function (event, editor) {
                        EventBus.$emit('update-text-elements');
                    },
                },
            },
        };
    },

    mounted() {
        this.initializeFroalaEditor();
    },

    methods: {
        initializeFroalaEditor() {
            $.FroalaEditor.DefineIcon('campaignFooterColorPicker', {
                template: 'image',
                SRC: 'https://cdn.honeycrm.com/app/text-colorpicker.png',
                ALT: 'Colors',
            });

            var self = this;
            $.FroalaEditor.RegisterCommand('campaignFooterColorPicker', {
                title: 'Open Color Picker',
                type: 'button',
                focus: false,
                undo: false,
                refreshAfterCallback: false,
                options: {},
                callback: function (cmd, val) {
                    self.openColorPicker(this);
                },
            });
        },

        openColorPicker(context) {
            this.froalaContext = context;

            var textColor = this.froalaContext.selection.endElement().style.color;
            if (textColor) {
                this.colorValue = textColor;
            } else {
                this.colorValue = '';
            }

            this.isColorPickerOpen = true;
            this.froalaContext.selection.save();

            this.setColorPickerPositioning();
        },

        closeColorPicker() {
            if (this.isColorPickerOpen) {
                this.isColorPickerOpen = false;
                this.froalaContext.selection.restore();
            }
        },

        setColorPickerPositioning() {
            var textEditor = this.$refs.appTextEditor;
            var selector = 'button[data-cmd="campaignFooterColorPicker"]';

            var colorPickerButton = textEditor.querySelector(selector);
            var btnTop = colorPickerButton.getBoundingClientRect().top;
            var btnBottom = colorPickerButton.getBoundingClientRect().bottom;
            var btnLeft = colorPickerButton.getBoundingClientRect().left;

            var btnHeight = btnBottom - btnTop;

            var colorPicker = this.$refs.colorPicker.$el;
            colorPicker.style.bottom = 325 + 'px';
            colorPicker.style.left = btnLeft - 110 + 'px';
        },

        updateTextColor(color) {
            this.froalaContext.selection.restore();

            if (this.froalaContext.selection.text()) {
                if (color.branding) {
                    this.froalaContext.format.apply('span', {
                        'data-branding': `${color.branding}`,
                    });
                } else {
                    this.removeBrandingAttributes();
                }
            }

            this.froalaContext.format.applyStyle('color', color.value);

            this.froalaContext.selection.save();
        },

        removeBrandingAttributes() {
            var branding = this.$helpers.getDefaultBranding();

            for (var i = 0; i < branding.length; i++) {
                this.froalaContext.format.remove('span', { 'data-branding': branding[i].key });
            }
        },
    },
};
